import React from 'react';

const ReportBucketIcon = (props) => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.0287 14.8242L15.2838 17.0588C15.192 17.334 14.9345 17.5195 14.6445 17.5195H8.35547C8.06545 17.5195 7.80796 17.334 7.71623 17.0588L6.97134 14.8242H0V22.3262C0 22.6983 0.301695 23 0.673828 23H22.3262C22.6983 23 23 22.6983 23 22.3262V14.8242H16.0287ZM14.6445 20.8887H8.35547C7.98334 20.8887 7.68164 20.587 7.68164 20.2148C7.68164 19.8427 7.98334 19.541 8.35547 19.541H14.6445C15.0167 19.541 15.3184 19.8427 15.3184 20.2148C15.3184 20.587 15.0167 20.8887 14.6445 20.8887Z"
      fill="#FB9318"
    />
    <path
      d="M8.24986 14.398L8.84116 16.1719H14.1589L14.7501 14.398C14.9336 13.8478 15.4486 13.4766 16.0287 13.4766H18.6875V9.88281H4.3125V13.4766H6.97134C7.55146 13.4766 8.0664 13.8478 8.24986 14.398Z"
      fill="#FB9318"
    />
    <path
      d="M5.66016 4.94141H17.3398V8.53516H5.66016V4.94141Z"
      fill="#FB9318"
    />
    <path
      d="M20.2421 2.3168C20.1706 2.01219 19.8989 1.79688 19.5861 1.79688H17.34V3.59375C18.0842 3.59375 18.6876 4.19714 18.6876 4.94141V8.53516C19.4319 8.53516 20.0353 9.13855 20.0353 9.88281V13.4766H22.8603L20.2421 2.3168Z"
      fill="#FB9318"
    />
    <path
      d="M4.31259 8.53516V4.94141C4.31259 4.19714 4.91598 3.59375 5.66025 3.59375V1.79688H3.41416C3.10128 1.79688 2.82959 2.01219 2.75812 2.3168L0.139893 13.4766H2.96494V9.88281C2.96494 9.13855 3.56833 8.53516 4.31259 8.53516Z"
      fill="#FB9318"
    />
    <path
      d="M15.3184 0H7.68164C7.30951 0 7.00781 0.301695 7.00781 0.673828V3.59375H15.9922V0.673828C15.9922 0.301695 15.6905 0 15.3184 0Z"
      fill="#FB9318"
    />
  </svg>
);

export default ReportBucketIcon;
